import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

function SitePage() {
  const { user } = useSelector(state => state.userState);
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'IFRAME_RESIZE' && iframeRef.current) {
        iframeRef.current.style.height = `${event.data.height}px`;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <iframe
        id='digi-card'
        ref={iframeRef}
        title='digi-card-iframe'
        className='digi-card-iframe'
        src={`${process.env.REACT_APP_DIGI_CARD_URL}?id=${user._id}`} />
    </>
  )
}

export default SitePage;
